﻿import { resp } from "./resp";
import { response_details_amount } from "./response_details_amount";

export class response_details {
    public paymentMethod: string | null = null;
    public transactionId: string | null = null;
    public amount: response_details_amount = new response_details_amount();
}